import React from "react";
import "../css/ColoredHead.css";
import { Row, Col, Container } from "react-bootstrap";

function ColoredHead({ top, middle, end, color, textcolor }) {
  return (
    <div
      className="colored-head__base"
      style={{ backgroundColor: color, color: textcolor }}
    >
      <div className="colored-head__div">
        <div className="colored-head__inner">{top}</div>
      </div>
      <div className="colored-head__div">
        <div>
          <img className="colored-head__img" src={middle}></img>
        </div>
      </div>
      <div className="colored-head__div">{end}</div>
    </div>
  );
}

export default ColoredHead;
